import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'

// UI

import {
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from '@chakra-ui/react'

//Hooks
import useOfferCostBudget from '@/features/offerCostBudgets/useOfferCostBudget'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
//Constant

const VendorDeclineUploadModal = ({ modalDetail, setModalDetail }) => {
  const { show, costBudgetId } = modalDetail

  const remark = useRef()

  const dispatch = useDispatch()

  const { useVendorDeclineQuotation } = useOfferCostBudget()
  const rejectVendorQuotation = useVendorDeclineQuotation()

  const closeModal = () => {
    setModalDetail({
      show: false,
    })
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const remarkValue = remark.current.value || ''

    try {
      dispatch(showLoadingOverlay())
      await rejectVendorQuotation.mutateAsync({
        costBudgetId,
        remark: remarkValue,
      })
      closeModal()
    } catch (err) {
      console.log(err)
      return
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }
  return (
    <Modal isOpen={show} onClose={closeModal} size="xl">
      <form onSubmit={onSubmit}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Decline Quotation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap="2">
              <p>Comment: </p>
              <Textarea name="remark" rows="5" ref={remark} />

              {/* <Flex gap="3">
                <Text size="sm">Documents:</Text>
                <input
                  type="file"
                  accept={allFileTypes}
                  name="file"
                  ref={fileInput}
                  onChange={handleFileChange}
                  multiple
                />
              </Flex> */}
            </Flex>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button colorScheme={'red'} type="submit">
                Decline
              </Button>
              <Button colorScheme="gray" onClick={closeModal}>
                Close
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  )
}
export default VendorDeclineUploadModal
